<template>
  <v-footer dark>
    <v-row>
      <v-col class="text-center">

<p>Registered Address: 1 Woodpecker Close<br/>
            East Leake, Loughborough<br/>
            England, LE12 6YN<br/>
            Registered in England and Wales</p>
<p>By using the website you agree to our <br /><v-btn text class="px-0 text-btn" @click="ScrollTo()" to="/terms"><span>Terms &amp; Conditions</span></v-btn> and <v-btn text class="px-0 text-btn" @click="ScrollTo()" to="/privacy"><span>Privacy Policy</span></v-btn></p>
         
          <v-divider></v-divider>

           <p>&copy; 
            {{ new Date().getFullYear() }} —
            <strong>9 Bit Digital Ltd<br/>Company Number: 09186693</strong></p>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  data: () => ({
    icons: [
      "fab fa-facebook",
      //"fab fa-twitter",
      //"fab fa-linkedin",
      //"fab fa-instagram"
    ]
  }),
  methods: {
    ScrollTo() {      
      this.$vuetify.goTo(0, {
        duration: 500,
        easing: 'easeInOutCubic',
      })
    }
  }
};
</script>
<style scoped>
.text-btn.vbtn::before
.text-btn.vbtn.active::before
{
  opacity: 0;
}
</style>